import { Injectable, inject } from '@angular/core';
import { InteractivityChecker } from '@angular/cdk/a11y';

@Injectable({ providedIn: 'root' })
export class InteractivityService {
  private interactivityChecker = inject<InteractivityChecker>(InteractivityChecker);

  getFirstTabbableElement(root: HTMLElement): HTMLElement | null {
    if (this.interactivityChecker.isFocusable(root) && this.interactivityChecker.isTabbable(root)) {
      return root;
    }
    const children = root.children;

    for (const child of children) {
      const tabbableChild = child.nodeType === Node.ELEMENT_NODE
        ? this.getFirstTabbableElement(child as HTMLElement)
        : null;
      if (tabbableChild !== null) {
        return tabbableChild;
      }
    }
    return null;
  }

}
